const arr = [
	{
		path: '/login',
		name: 'login',
		component: r => require.ensure([], () => r(require('template/account/login.vue')), 'login'),
		meta: {
			level: 0,
			title: '登录'
		}
	},
	{
		path: '/signup',
		name: 'signup',
		component: r =>
			require.ensure([], () => r(require('template/account/signup.vue')), 'signup'),
		meta: {
			level: 0,
			title: '注册'
		}
	},
	{
		path: '/forget',
		name: 'forget',
		component: r =>
			require.ensure([], () => r(require('template/account/forget.vue')), 'signup'),
		meta: {
			level: 0,
			title: '忘记密码'
		}
	},
	{
		path: '/home',
		name: 'home',
		component: r => require.ensure([], () => r(require('template/home.vue')), 'home'),
		meta: {
			level: 0,
			title: '首页'
		}
	},
	{
		path: '/cooprate',
		name: 'cooprate',
		component: r => require.ensure([], () => r(require('template/cooprate.vue')), 'cooprate'),
		meta: {
			level: 0,
			title: '合作体系'
		}
	},
	{
		path: '/case',
		name: 'case',
		component: r => require.ensure([], () => r(require('template/case.vue')), 'case'),
		meta: {
			level: 0,
			title: '案例与支持'
		}
	},
	{
		path: '/notify',
		name: 'notify',
		component: r => require.ensure([], () => r(require('template/notify.vue')), 'notify'),
		meta: {
			level: 0,
			title: '消息中心'
		}
	},
	{
		path: '/profile',
		name: 'profile',
		component: r => require.ensure([], () => r(require('template/profile.vue')), 'profile'),
		meta: {
			level: 0,
			title: '个人中心'
		}
	},
	{
		path: '/basic',
		name: 'basic',
		component: r => require.ensure([], () => r(require('template/basic.vue')), 'basic'),
		meta: {
			level: 0,
			title: '基本信息'
		}
	},
	{
		path: '/certiPrint',
		name: 'certiPrint',
		component: r =>
			require.ensure([], () => r(require('template/certiPrint.vue')), 'certiPrint'),
		meta: {
			level: 0,
			title: '授权证书'
		}
	},
	{
		path: '/apply',
		name: 'apply',
		component: r => require.ensure([], () => r(require('template/apply.vue')), 'apply'),
		meta: {
			level: 0,
			title: '加盟信息'
		}
	},
	{
		path: '/opportunity',
		name: 'opportunity',
		component: r =>
			require.ensure([], () => r(require('template/opportunity.vue')), 'opportunity'),
		meta: {
			level: 0,
			title: '商机管理'
		}
	},
	{
		path: '/contact',
		name: 'contact',
		component: r => require.ensure([], () => r(require('template/contact.vue')), 'contact'),
		meta: {
			level: 0,
			title: '联系我们'
		}
	},
	{
		path: '/partner',
		name: 'partner',
		component: r => require.ensure([], () => r(require('template/partner.vue')), 'partner'),
		meta: {
			level: 1,
			title: '营销伙伴'
		}
	},
	{
		path: '/stuff',
		name: 'stuff',
		component: r => require.ensure([], () => r(require('template/stuff.vue')), 'stuff'),
		meta: {
			level: 1,
			title: '区域实施伙伴'
		}
	},
	{
		path: '/develop',
		name: 'develop',
		component: r => require.ensure([], () => r(require('template/develop.vue')), 'develop'),
		meta: {
			level: 1,
			title: '开发伙伴'
		}
	},
	{
		path: '/goodsManage',
		name: 'goodsManage',
		component: r => require.ensure([], () => r(require('template/goodsManage.vue')), 'market'),
		meta: {
			level: 1,
			title: '商品管理'
		}
	},
	{
		path: '/goodsEdit/:id',
		name: 'goodsEdit',
		component: r => require.ensure([], () => r(require('template/goodsEdit.vue')), 'goodsEdit'),
		meta: {
			level: 2,
			title: '商品信息'
		}
	},
	{
		path: '/goodsDetail/:id',
		name: 'goodsDetail',
		component: r =>
			require.ensure([], () => r(require('template/goodsDetail.vue')), 'goodsDetail'),
		meta: {
			level: 2,
			title: '商品详情'
		}
	},
	{
		path: '/market',
		name: 'market',
		component: r => require.ensure([], () => r(require('template/market.vue')), 'market'),
		meta: {
			level: 1,
			title: '生态商城'
		}
	},
	{
		path: '/ecological',
		name: 'ecological',
		component: r =>
			require.ensure([], () => r(require('template/ecological.vue')), 'ecological'),
		meta: {
			level: 1,
			title: '生态联盟伙伴'
		}
	},
	{
		path: '/orderManage',
		name: 'orderManage',
		component: r =>
			require.ensure([], () => r(require('template/orderManage.vue')), 'orderManage'),
		meta: {
			level: 1,
			title: '订单管理'
		}
	}
]

arr.push({
	path: '*',
	redirect: '/home',
	meta: {
		level: 1,
		title: '默认首页'
	}
})

export default arr
